import { render, staticRenderFns } from "./hiButton.vue?vue&type=template&id=fc8e651a&"
import script from "./hiButton.vue?vue&type=script&lang=js&"
export * from "./hiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports